import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ClinicalStaffService } from './clinical-staff.service';
import { ClinicalStaffComponent } from './clinical-staff.component';

import { SharedModule } from '../shared/shared.module';


@NgModule({
	imports: [
		BrowserModule,
		CommonModule,
		HttpModule,
		RouterModule,
		SharedModule,
	],
	declarations: [
		ClinicalStaffComponent
	],
	providers: [
		ClinicalStaffService
	],
})
export class ClinicalStaffModule {}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/clinical-staff/clinical-staff.module.ts